import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Table,
  Input,
  Form,
  Space,
  InputNumber,
  Row,
  Col,
  message,
  Modal,
  Spin,
  Tooltip,
  Card,
  Tag,
} from "antd";
import {
  SaveOutlined,
  FilterOutlined,
  ReloadOutlined,
  FileExcelOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import { excelForPostOfficeDG } from "../export/ExportPostOfficeDG"; // ปรับ path ให้ตรงกับโปรเจค
import PrintPDFAddress from "../pdf/PrintPDFAddress";
import PrintPDF from "../pdf/PrintPDF";
import Search from "antd/es/input/Search";
import {
  baseUrlAREA,
  HEADERS_BASIC,
  UPDATE_PARCELNO,
} from "../../../API/apiUrlsNew";

// --- Component Input แยก เพื่อประสิทธิภาพ ---
const AutoFocusInput = React.memo(
  ({
    record,
    index,
    fieldName,
    placeholder,
    onComplete,
    isError,
    clearError,
  }) => {
    return (
      <Form.Item
        name={["rows", record.key, fieldName]}
        style={{ margin: 0 }}
        validateStatus={isError ? "error" : ""}
        rules={[{ len: 13, message: "13 หลัก", warningOnly: true }]}
        getValueFromEvent={(e) => e.target.value}
      >
        <Input
          id={`input-${fieldName}-${index}`}
          placeholder={placeholder}
          maxLength={13}
          status={isError ? "error" : ""}
          style={{ textAlign: "center" }}
          onChange={(e) => {
            const v = e.target.value.trim();
            if (isError && clearError) clearError();
            if (v.length === 13) onComplete(index, v);
          }}
        />
      </Form.Item>
    );
  },
);

const AddBarcode2 = ({
  data,
  date,
  onBack,
  refreshCalendar,
  selectedContract,
  roundDate,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [masterData, setMasterData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [completedCount, setCompletedCount] = useState(0);
  const [errorMap, setErrorMap] = useState({});

  // Pagination & Filter
  const [rangeStart, setRangeStart] = useState(1);
  const [rangeEnd, setRangeEnd] = useState(0);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  //เช็คการพิมพ์
  const [printingAll, setPrintingAll] = useState(false);

  //DB2
  const [dataDB2, setDataDB2] = useState([]);
  const [dataDB2Filter, setDataDB2Filter] = useState([]);

  const [dataClose, setDataClose] = useState([]);

  // --- 1. Init Data ---
  useEffect(() => {
    if (data && data.length > 0) {
      // เตรียมข้อมูล ใส่ key และค่าเริ่มต้น
      const initData = data.map((item, index) => ({
        ...item,
        key: item.key || item.id || index, // ควรมี key ที่ไม่ซ้ำ
        parcelNo: item.parcelNo || undefined,
        parcelNoResponse: item.parcelNoResponse || undefined,
      }));

      setMasterData(initData);
      setDisplayData(initData);
      setRangeEnd(initData.length);
      setPagination((prev) => ({ ...prev, current: 1 }));
      setErrorMap({});
      setCompletedCount(0);
      form.resetFields();
    } else {
      setMasterData([]);
      setDisplayData([]);
    }
  }, [data, form]);

  // --- 2. Logic คำนวณความคืบหน้า ---
  const updateProgress = () => {
    const currentFormValues = form.getFieldsValue().rows || {};
    let count = 0;
    masterData.forEach((row) => {
      const formRow = currentFormValues[row.key] || {};
      const pNo =
        formRow.parcelNo !== undefined ? formRow.parcelNo : row.parcelNo;
      const pRes =
        formRow.parcelNoResponse !== undefined
          ? formRow.parcelNoResponse
          : row.parcelNoResponse;
      if (pNo && pRes && pNo.length === 13 && pRes.length === 13) count++;
    });
    setCompletedCount(count);
  };

  useEffect(() => {
    updateProgress();
    if (dataDB2.length === 0) {
      handleCheckClose(data, "start");
    }
  }, [masterData]);

  // const saveCurrentPageToMaster = () => {
  //   const formValues = form.getFieldsValue();
  //   const rawRows = formValues.rows || {};
  //   if (Object.keys(rawRows).length === 0) return;

  //   setMasterData(prev => {
  //     const newData = [...prev];
  //     Object.keys(rawRows).forEach(key => {
  //       const rowData = rawRows[key];
  //       const index = newData.findIndex(d => String(d.key) === String(key));
  //       if (index > -1) newData[index] = { ...newData[index], ...rowData };
  //     });
  //     return newData;
  //   });
  // };

  const saveCurrentPageToMaster = () => {
    // 1. ดึงข้อมูลทั้งหมดจาก Form (Ant Design)
    const formValues = form.getFieldsValue();

    // 2. ดึงเฉพาะส่วนของ rows ออกมา ถ้าไม่มีให้เป็น Object ว่าง
    const rawRows = formValues.rows || {};

    // 3. ถ้าไม่มีการแก้ไขข้อมูลใดๆ ในหน้าปัจจุบัน (rawRows ว่าง) ให้หยุดการทำงานทันที
    if (Object.keys(rawRows).length === 0) return;

    // 4. แยก newData ออกมาคำนวณข้างนอก โดย Clone จาก masterData ชุดเดิม
    const newData = [...masterData];

    // 5. วนลูปเพื่อนำข้อมูลที่แก้ใน Form (rawRows) ไปอัปเดตลงใน newData
    Object.keys(rawRows).forEach((key) => {
      const rowData = rawRows[key];

      // ค้นหา Index ใน MasterData ที่มี key ตรงกัน
      const index = newData.findIndex((d) => String(d.key) === String(key));

      if (index > -1) {
        // อัปเดตข้อมูลแถวนั้นๆ โดยการ Merge ข้อมูลเดิมเข้ากับค่าใหม่จาก Form
        newData[index] = {
          ...newData[index],
          ...rowData,
        };
      }
    });

    // 6. นำ newData ที่อัปเดตเรียบร้อยแล้วไปเก็บลง State
    setMasterData(newData);

    // 7. ส่ง newData ไปประมวลผลต่อที่ handleCheckClose ทันที
    // เพื่อให้ Logic การเช็คเงื่อนไขได้รับข้อมูลล่าสุด (ไม่ต้องรอ State อัปเดต)
    // handleCheckClose(newData, "filter");

    const sliceddb2 = newData.slice(rangeStart - 1, rangeEnd);
    handleCheckClose(sliceddb2, "filter");
  };

  const changePage = (newPage, newPageSize) => {
    saveCurrentPageToMaster();
    setPagination((prev) => ({
      ...prev,
      current: newPage,
      pageSize: newPageSize || prev.pageSize,
    }));
  };

  const handleNextPageFocus = () => {
    const totalPages = Math.ceil(displayData.length / pagination.pageSize);
    if (pagination.current < totalPages) {
      changePage(pagination.current + 1);
      message.loading({ content: "ถัดไป...", key: "pageLoad", duration: 0.5 });
      setTimeout(() => {
        const input = document.getElementById(`input-parcelNo-0`);
        if (input) input.focus();
      }, 300);
    } else {
      saveCurrentPageToMaster();
      message.success("จบรายการช่วงนี้แล้ว");
    }
  };

  const getEffectiveData = () => {
    const currentFormValues = form.getFieldsValue().rows || {};
    return masterData.map((row) => {
      const formRow = currentFormValues[row.key] || {};
      return { ...row, ...formRow };
    });
  };

  const handleInputComplete = (rowIndex, type, value) => {
    const pageSize = pagination.pageSize;
    const startIndex = (pagination.current - 1) * pageSize;
    const record = displayData[startIndex + rowIndex];
    if (!record) return;

    const rowKey = record.key;
    const fieldName = type === "mail" ? "parcelNo" : "parcelNoResponse";

    // เช็คซ้ำ Global
    const effectiveData = getEffectiveData();
    const isDuplicate = effectiveData.find(
      (d) =>
        (d.parcelNo === value &&
          (d.key !== rowKey || fieldName !== "parcelNo")) ||
        (d.parcelNoResponse === value &&
          (d.key !== rowKey || fieldName !== "parcelNoResponse")),
    );

    if (isDuplicate) {
      Modal.error({ title: "เลขซ้ำ", content: `เลข ${value} ถูกใช้ไปแล้ว` });
      setErrorMap((prev) => ({ ...prev, [`${rowKey}-${fieldName}`]: true }));
      form.setFieldValue(["rows", rowKey, fieldName], null);
      return;
    }

    // ถ้าผ่าน -> เคลียร์ error
    setErrorMap((prev) => {
      const newMap = { ...prev };
      delete newMap[`${rowKey}-${fieldName}`];
      return newMap;
    });

    setTimeout(updateProgress, 50);

    // ย้าย Focus
    if (type === "mail") {
      document.getElementById(`input-parcelNoResponse-${rowIndex}`)?.focus();
    } else {
      const currentItemsOnPage = displayData.slice(
        startIndex,
        startIndex + pageSize,
      ).length;
      if (rowIndex === currentItemsOnPage - 1) {
        handleNextPageFocus();
      } else {
        document.getElementById(`input-parcelNo-${rowIndex + 1}`)?.focus();
      }
    }
  };

  const onFinish = async () => {
    // setLoading(true);
    saveCurrentPageToMaster(); // อัปเดตข้อมูลล่าสุดเข้า masterData ก่อน

    // ดึงข้อมูลล่าสุดจริงๆ อีกทีหลัง saveCurrentPageToMaster ทำงานเสร็จ (ผ่าน getEffectiveData หรือรอ state update)
    // เพื่อความชัวร์ ใช้การ merge ตรงนี้เลย
    const currentFormValues = form.getFieldsValue().rows || {};
    const finalData = masterData.map((row) => {
      const formRow = currentFormValues[row.key] || {};
      return { ...row, ...formRow };
    });

    const dataToSend = finalData.filter(
      (item) =>
        item.parcelNo &&
        item.parcelNoResponse &&
        item.parcelNo.length === 13 &&
        item.parcelNoResponse.length === 13,
    );

    if (dataToSend.length === 0) {
      setLoading(false);
      return message.warning("ไม่พบข้อมูลที่ครบถ้วน");
    }

    try {
      const res = await axios.post(UPDATE_PARCELNO, dataToSend, {
        headers: HEADERS_BASIC,
      });
      if (res.status === 200) {
        message.success("บันทึกสำเร็จ");
        if (refreshCalendar) refreshCalendar();
      }
    } catch (error) {
      if (error.response?.status === 409) {
        Modal.error({
          title: "บันทึกไม่สำเร็จ",
          content: `เลขซ้ำ: ${error.response.data.duplicateValue}`,
        });
      } else {
        message.error("บันทึกผิดพลาด");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleExportExcel = async () => {
    setLoading(true);
    // saveCurrentPageToMaster();

    const filteredData = dataDB2Filter.filter((e) => {
      // ตรวจสอบว่ามี parcelNo และ parcelNoResponse (และต้องไม่เป็นค่าว่างหรือ null)
      return e.parcelNo && e.parcelNoResponse;
    });

    const currentFormValues = form.getFieldsValue().rows || {};
    // const mergedDisplayData = displayData.map(row => ({ //ตัวปกติ
    const mergedDisplayData = filteredData.map((row) => ({
      //ตัวตัดที่ปิดบัญชีแล้ว
      ...row,
      ...(currentFormValues[row.key] || {}),
    }));

    let useData =
      selectedRowKeys.length > 0
        ? mergedDisplayData.filter((r) => selectedRowKeys.includes(r.key))
        : mergedDisplayData;

    try {
      await excelForPostOfficeDG(useData, 1, selectedContract);
      message.success("Export สำเร็จ");
    } catch (e) {
      console.error(e);
      message.error("Export ผิดพลาด");
    } finally {
      setLoading(false);
    }
  };

  // --- 5. Render ---
  // Sync Form Values when Page Changes
  useEffect(() => {
    const initialValues = {};
    const startIndex = (pagination.current - 1) * pagination.pageSize;
    const endIndex = startIndex + pagination.pageSize;
    const currentPageData = displayData.slice(startIndex, endIndex);

    currentPageData.forEach((r) => {
      // หาข้อมูลล่าสุดจาก masterData (ที่อาจถูกอัปเดตแล้ว)
      const masterRecord =
        masterData.find((d) => String(d.key) === String(r.key)) || r;
      initialValues[r.key] = {
        parcelNo: masterRecord.parcelNo,
        parcelNoResponse: masterRecord.parcelNoResponse,
      };
    });
    form.setFieldsValue({ rows: initialValues });
  }, [pagination.current, displayData, masterData, form]);

  const handleFilter = () => {
    saveCurrentPageToMaster();
    const sliced = masterData.slice(rangeStart - 1, rangeEnd);
    setDisplayData(sliced);

    const sliceddb2 = dataDB2.slice(rangeStart - 1, rangeEnd);
    handleCheckClose(sliceddb2, "filter");
    // setDataDB2Filter(sliceddb2)

    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  const handleCheckClose = (value, type) => {
    const trueList = [];
    const falseList = [];

    value.forEach((e) => {
      if (e.flagClose) {
        trueList.push(e); // true
      } else {
        falseList.push(e); // false/null/undefined
      }
    });

    if (type === "start") {
      setDataClose(trueList);
      setDataDB2(value ? value : []);
      setDataDB2Filter(falseList ? falseList : []);
    } else if (type === "filter") {
      setDataDB2Filter(falseList ? falseList : []);
    } else if (type === "reset") {
      setDataDB2Filter(falseList ? falseList : []);
    }
  };

  const onSearch = (value) => {
    setLoading(true);
    let result;

    if (value) {
      result = masterData.filter(
        (item) =>
          (item.contractNo && item.contractNo.includes(value.trim())) ||
          (item.SNAM && item.SNAM.includes(value.trim())) ||
          (item.NAME1 && item.NAME1.includes(value.trim())) ||
          (item.NAME2 && item.NAME2.includes(value.trim())),
        // ||
        // (item.REGNO && item.REGNO.includes(value.trim()))
      );
    } else {
      result = masterData;
      setDisplayData(result);
    }

    setTimeout(() => {
      setLoading(false);
    }, 250);
    setDisplayData(result);
    handleCheckClose(result, "filter");
  };

  const columns = useMemo(
    () => [
      {
        title: "ลำดับ",
        dataIndex: "key",
        width: 70,
        align: "center",
        fixed: "left",
      },
      { title: "สัญญา", dataIndex: "contractNo", width: 130, align: "center" },
      // { title: "ชื่อ-นามสกุล", dataIndex: "customerFullName", width: 180, ellipsis: true },
      {
        title: "ชื่อ-นามสกุล",
        dataIndex: "customerFullName",
        width: 180,
        ellipsis: true,
        render: (text, record) => (
          <>
            {record?.customerFullName} (คค.{record.GARNO})
          </>
        ),
      },
      {
        title: "EMS ไป",
        dataIndex: "parcelNo",
        width: 180,
        align: "center",
        render: (_, r, i) => (
          <AutoFocusInput
            record={r}
            index={i}
            fieldName="parcelNo"
            placeholder="EMS ไป"
            isError={!!errorMap[`${r.key}-parcelNo`]}
            clearError={() =>
              setErrorMap((p) => {
                const n = { ...p };
                delete n[`${r.key}-parcelNo`];
                return n;
              })
            }
            onComplete={(idx, val) => handleInputComplete(idx, "mail", val)}
          />
        ),
      },
      {
        title: "EMS กลับ",
        dataIndex: "parcelNoResponse",
        width: 180,
        align: "center",
        render: (_, r, i) => (
          <AutoFocusInput
            record={r}
            index={i}
            fieldName="parcelNoResponse"
            placeholder="EMS กลับ"
            isError={!!errorMap[`${r.key}-parcelNoResponse`]}
            clearError={() =>
              setErrorMap((p) => {
                const n = { ...p };
                delete n[`${r.key}-parcelNoResponse`];
                return n;
              })
            }
            onComplete={(idx, val) => handleInputComplete(idx, "response", val)}
          />
        ),
      },
    ],
    [pagination, displayData, errorMap],
  );

  return (
    <div style={{ padding: "0 20px" }}>
      <Spin spinning={loading || printingAll}>
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col style={{ textAlign: "start" }}>
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={onBack}
              style={{ marginRight: 16 }}
            >
              กลับปฏิทิน
            </Button>
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              วันที่: {dayjs(date).format("DD/MM/YYYY")}
            </span>
          </Col>
          <Col style={{ textAlign: "end" }}>
            <span
              style={{
                marginLeft: 16,
                color: completedCount === masterData.length ? "green" : "#666",
              }}
            >
              {completedCount === masterData.length
                ? "🎉 ครบแล้ว!"
                : `✅ เสร็จ: ${completedCount}/${masterData.length}`}
            </span>
          </Col>
        </Row>
        <Card style={{ marginBottom: 16, background: "#f5f5f5" }}>
          <Row gutter={[16, 16]} align="middle">
            <Col span={24} style={{ textAlign: "end" }}>
              <span>แสดง: {displayData.length} รายการ</span>
            </Col>
            <Col xs={24} md={12}>
              <Space>
                <span style={{ fontWeight: 600 }}>ลำดับ:</span>
                <InputNumber
                  min={1}
                  max={masterData.length}
                  value={rangeStart}
                  onChange={setRangeStart}
                />
                <span>ถึง</span>
                <InputNumber
                  min={1}
                  max={masterData.length}
                  value={rangeEnd}
                  onChange={setRangeEnd}
                />
                <Button
                  type="primary"
                  icon={<FilterOutlined />}
                  onClick={handleFilter}
                >
                  ดึงข้อมูล
                </Button>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    saveCurrentPageToMaster();
                    setDisplayData(masterData);

                    handleCheckClose(dataDB2, "reset");
                    setRangeStart(1);
                    setRangeEnd(masterData.length);
                    setPagination((prev) => ({ ...prev, current: 1 }));
                  }}
                >
                  ทั้งหมด
                </Button>
              </Space>
            </Col>
            <Col xs={24} md={12} style={{ textAlign: "right" }}>
              <Space>
                {selectedContract?.value === "lsfhp" ? (
                  <Button disabled> บัญชี 1 ไม่สามารถดำเนินการได้</Button>
                ) : dataDB2Filter?.length === 0 ? (
                  <Tooltip
                    placement="bottom"
                    title={
                      dataDB2Filter.length > 0 ? null : "โหลดข้อมูลไม่สำเร็จ !"
                    }
                  >
                    <Button disabled>พิมพ์ PDF</Button>
                  </Tooltip>
                ) : (
                  <PrintPDF
                    dataTabelB={dataDB2Filter}
                    selectedContract={selectedContract}
                    printingAll={printingAll}
                    setPrintingAll={setPrintingAll}
                    roundDate={roundDate}
                  />
                )}
                {selectedContract?.value === "lsfhp" ? (
                  <Button disabled> บัญชี 1 ไม่สามารถดำเนินการได้</Button>
                ) : dataDB2Filter?.length === 0 ? (
                  <Tooltip
                    placement="bottom"
                    title={
                      dataDB2Filter.length > 0 ? null : "โหลดข้อมูลไม่สำเร็จ !"
                    }
                  >
                    <Button disabled>พิมพ์สติกเกอร์</Button>
                  </Tooltip>
                ) : (
                  <PrintPDFAddress dataTabelB={dataDB2Filter} />
                )}
                <Button
                  icon={<FileExcelOutlined />}
                  type="primary"
                  style={{ backgroundColor: "green", borderColor: "green" }}
                  onClick={handleExportExcel}
                >
                  Export
                </Button>
              </Space>
            </Col>
            <Col span={24} style={{ textAlign: "end" }}>
              <Search
                placeholder="ค้นหาสัญญา"
                enterButton
                onSearch={onSearch}
                style={{
                  width: "auto",
                  borderRadius: "8px",
                }}
                size="large"
              />
            </Col>
          </Row>
        </Card>
        {dataClose?.length > 0 ? (
          <Card style={{ marginBottom: 16, background: "#f5f5f5" }}>
            <b style={{ fontSize: "18px" }}> สัญญาที่ปิดไปแล้ว </b>
            <p>
              {[...new Set(dataClose?.map((item) => item.contractNo))].map(
                (contractNo, index) => (
                  <Tag
                    key={contractNo} // ใช้เลขสัญญาเป็น Key ให้ไม่ซ้ำ
                    color="red"
                    style={{ margin: 5 }}
                  >
                    {contractNo}
                  </Tag>
                ),
              )}
            </p>
          </Card>
        ) : null}

        {/* Table */}
        <Form form={form}>
          <Table
            rowKey="key"
            columns={columns}
            dataSource={displayData}
            size="small"
            bordered
            scroll={{ y: 500, x: 800 }}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: displayData.length,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100", "200"],
              onChange: (p, s) => changePage(p, s),
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} จาก ${total}`,
            }}
            rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
            onRow={(record) => {
              return {
                style: {
                  // เช็คเงื่อนไขตรงนี้: ถ้า flagClose เป็น true ให้พื้นหลังแดง (ใช้สีแดงอ่อนๆ จะอ่านง่ายกว่าแดงสด)
                  backgroundColor: record.flagClose ? "#ffccc7" : "inherit",
                },
              };
            }}
          />
        </Form>

        <Row style={{ marginTop: 16, justifyContent: "flex-end" }}>
          <Button
            type="primary"
            onClick={onFinish}
            icon={<SaveOutlined />}
            size="large"
            style={{ width: 150 }}
          >
            บันทึกข้อมูล
          </Button>
        </Row>
      </Spin>
    </div>
  );
};

export default AddBarcode2;
